<div class="gradient-picker">
    <!-- Gradient Preview -->
    <div class="preview" [style.background]="getGradiantValue() | gradientCss">
        @if (fieldsToShow.includes("reset") && false) {
        <div class="gradient-reset" pTooltip="Reset" tooltipPosition="left" (click)="resetGradient()">
            <i class="pi pi-refresh"></i>
        </div>
        }
    </div>

    <!-- Color Stop Bar -->
    <div class="controls">
        <div class="stop-bar-container">
            <div #stopBar class="stop-bar" [class.can-add-color]="colorStops && colorStops.length < maxColors"
                [style.background]="getGradiantValue() | gradientCss" (click)="addColorAtPosition($event)">
                <div *ngFor="let stop of colorStops; let i = index" class="color-stop"
                    [class.active]="selectedStopIndex === i" [style.left.%]="stop.position"
                    (mousedown)="startDrag(i, $event)" (click)="selectStop(i, $event)">
                    <div class="stop-handle" [style.background]="stop.color">
                        <div class="remove" *ngIf="colorStops && colorStops.length > minColors" (click)="removeColorStop(i, $event)">
                            <i class="pi pi-times"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Selected Color Controls -->
        <ng-container *ngIf="selectedStopIndex !== null">
            <div class="neo-grid neo-grid-cols-2" *ngIf="colorStops">
                <div class="neo-input-wrapper color-input-wrapper">
                    <label>Color</label>
                    <input pInputText type="text" [(ngModel)]="colorStops[selectedStopIndex].color"
                        (input)="validateColorInput($event)" (change)="onGradientChange()" placeholder="#000000"
                        class="color-text-input" />

                    <input #colorPicker type="color" [(ngModel)]="colorStops[selectedStopIndex].color"
                        (change)="onGradientChange()" class="hidden-color-input" />

                    <div class="color-preview" (click)="colorPicker.click()"
                        [style.background]="colorStops[selectedStopIndex].color"></div>
                </div>

                <div class="neo-input-wrapper">
                    <label>Position</label>
                    <p-inputGroup>
                        <p-inputNumber [(ngModel)]="colorStops[selectedStopIndex].position"
                            (change)="onGradientChange()" [min]="0" [max]="100"></p-inputNumber>
                        <p-inputGroupAddon>%</p-inputGroupAddon>
                    </p-inputGroup>
                </div>
            </div>
        </ng-container>

        @if (fieldsToShow.includes("type")) {
        <div class="neo-input-wrapper">
            <label>Type</label>
            <p-select [options]="[
                        { label: 'Linear', value: 'linear' },
                        { label: 'Radial', value: 'radial' }
                    ]" [(ngModel)]="gradientType" (change)="onGradientChange()"></p-select>
        </div>
        }

        @if (fieldsToShow.includes("rotation") || fieldsToShow.includes("reset")) {
        <div class="neo-grid neo-grid-cols-1"
            [class.neo-grid-cols-2]="fieldsToShow.includes('rotation') && fieldsToShow.includes('reset')">
            <div class="neo-input-wrapper">
                <label>Rotation</label>
                <p-inputGroup>
                    <p-inputNumber [(ngModel)]="angle" (change)="onGradientChange()" [min]="0"
                        [max]="360"></p-inputNumber>
                    <p-inputGroupAddon>
                        <i class="pi pi-compass"></i>
                    </p-inputGroupAddon>
                </p-inputGroup>
            </div>
            <div class="neo-input-wrapper">
                <label style="opacity: 0;">Reset</label>
                <button (click)="resetGradient()" class="neo-btn outline" style="margin: 1vh 0;">
                    Reset to default
                </button>
            </div>
        </div>
        }
    </div>
</div>